export function slug(title: string): string {
  return title
    .normalize('NFD') // decompose accented chars (é → e + combining accent)
    .replace(/\p{Mn}/gu, '') // strip the combining diacritical marks, leaving base letters (é → e)
    .replace(/[^a-zA-Z0-9]+/g, '-') // replace spaces and non-alphanumeric runs with "-"
    .replace(/^-|-$/g, '') // trim any leading or trailing "-"
    .toLowerCase();
}
